import { GetCategoryBySlugViewModel } from '@/types/api'
import { CombinationSlugPageViewModel } from '@/types/cml-api'

import { PLPBasicMetasProps } from '../types'

export const isCombinationSlugPageViewModel = (
    basicMetas?: PLPBasicMetasProps | CombinationSlugPageViewModel
): basicMetas is CombinationSlugPageViewModel => Boolean(basicMetas && 'facet' in basicMetas)

export const isCategoryBasicMeta = (
    basicMetas?: PLPBasicMetasProps
): basicMetas is Partial<GetCategoryBySlugViewModel> => {
    return !!basicMetas && 'nameEn' in basicMetas
}
